import { type TestProps } from '@direct-frontend/components';
import { ONBOARDING_LITE_STEPS } from '#shared/api/onboarding';
import { liteStepsProps, liteSubtasksProps } from '../../model/onboardingLiteStages';
import { OnboardingStepsRenderer } from '../OnboardingStepsRenderer';
import { LitePublishButton } from './LitePublishButton';
import { LiteWelcomeModal } from './LiteWelcomeModal';

export function LiteOnboardingStepper(props: TestProps) {
    return (
        <>
            <LiteWelcomeModal />
            <OnboardingStepsRenderer
                {...props}
                PublishButton={LitePublishButton}
                publishSlug={ONBOARDING_LITE_STEPS.PUBLISH}
                stepsProps={liteStepsProps}
                subtasksProps={liteSubtasksProps}
            />
        </>
    );
}
